import React from "react";

import styled from "styled-components";



import { Form } from "rsuite";

const CustomField = ({ name, message, label, widthLabel, accepter, error, formGroupExtraStyle, ...props }) => {
    const formGroupStyle = formGroupExtraStyle ? formGroupExtraStyle : { marginBottom: 10, width: "100%" };
    return (
        <StyledFormGroup className={error ? "has-error" : ""} style={formGroupStyle}>
            {label &&
                <Form.ControlLabel style={{ width: "100%", textAlign: "left", display: "block" }}>{label}</Form.ControlLabel>
            }
            <StyledFieldWrapper>
                <Form.Control
                    name={name}
                    accepter={accepter}
                    errorMessage={error}
                    errorPlacement="topRight"
                    {...props}
                />
            </StyledFieldWrapper>
        </StyledFormGroup>
    );
};

export default CustomField;

const StyledFieldWrapper = styled.div`
    max-width: 250px;
`;

const StyledFormGroup = styled(Form.Group)`
    && {
        .rs-icon {
            position: absolute;
            right: 10px;
            color: var(--color-green);
        }
    }
`;